import { useEffect } from 'react';

function BannerManager() {
  useEffect(() => {
    const bannerContainer =
      document.getElementsByClassName('alert-box-wrapper')[0];

    const bannerExists = document.getElementsByClassName('alert-box')[0];

    if (!bannerExists) {
      const banner = document.createElement('div');
      banner.className = 'alert-box success';
      banner.setAttribute('data-alert', 'true');

      bannerContainer?.append(banner);

      banner.style.display = 'none';
    }
  }, []);

  return null;
}

export default BannerManager;
